module.exports = __webpack_public_path__ + "img/CN-邀请1.eb6f11e0.png";